/**
 * Countdown hook — returns days/hours/mins/secs until a given ISO date.
 */
import { useEffect, useState } from "react";

export function useCountdown(isoTarget) {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    if (!isoTarget) return { d: 0, h: 0, m: 0, s: 0, done: true, totalMs: 0 };
    const target = new Date(isoTarget).getTime();
    const diff = Math.max(0, target - now);
    const d = Math.floor(diff / (24 * 3600 * 1000));
    const h = Math.floor((diff / (3600 * 1000)) % 24);
    const m = Math.floor((diff / 60000) % 60);
    const s = Math.floor((diff / 1000) % 60);
    return { d, h, m, s, done: diff <= 0, totalMs: diff };
}
